import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.918.5a11.25 11.25 0 0 0-9.45 5.146C1.468 7.194 1.046 8.8.92 10.423L.917 14.5a3 3 0 0 0 3 3h2v-8H3.055a7.604 7.604 0 0 1 1.094-2.77 9.248 9.248 0 0 1 15.537 0c.496.768.835 1.638 1.054 2.57.015.067.028.133.04.2h-2.862v8h2.343a7.216 7.216 0 0 1-1.063 1.818C18.1 20.665 16.474 21.5 14.181 21.5h-.263a2 2 0 1 0-2 2h2.263c2.842 0 5.058-1.066 6.568-2.919 1.483-1.82 2.21-4.305 2.316-7.042.058-1.506-.01-3.124-.373-4.678a9.553 9.553 0 0 0-1.326-3.215A11.248 11.248 0 0 0 11.918.5Zm8 11h1.132c.04.644.041 1.301.016 1.961-.028.72-.103 1.4-.223 2.039h-.925v-4Zm-17 3v-3h1v4a1 1 0 0 1-1-1Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.661 13 8.917 7.58v10.84L16.661 13Zm-3.487 0-2.256 1.58v-3.16L13.174 13Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionPlayCall24 = createIcon(IconComponent);